import type { PopoverPosition, PopoverRect, PopoverState } from './popoverTypes'

export const POPOVER_DEFAULT_POSITIONS: PopoverPosition[] = [
  'top',
  'left',
  'right',
  'bottom',
]

export const POPOVER_AVAILABLE_HEIGHT_PROPERTY = '--popover-available-height'

export const POPOVER_EMPTY_CLIENT_RECT: PopoverRect = {
  top: 0,
  left: 0,
  bottom: 0,
  height: 0,
  right: 0,
  width: 0,
}

export const POPOVER_EMPTY_STATE: PopoverState = {
  align: 'start',
  nudgedLeft: 0,
  nudgedTop: 0,
  position: 'bottom',
  padding: 0,
  childRect: POPOVER_EMPTY_CLIENT_RECT,
  popoverRect: POPOVER_EMPTY_CLIENT_RECT,
  parentRect: POPOVER_EMPTY_CLIENT_RECT,
  boundaryRect: POPOVER_EMPTY_CLIENT_RECT,
  boundaryInset: 0,
  violations: POPOVER_EMPTY_CLIENT_RECT,
  hasViolations: false,
}
